<template>
  <div class="alarm-settings-page">
    <!-- 返回 -->
    <div class="row back-btn" @click="toMainPage">
      <i class="el-icon-arrow-left"></i>
    </div>
    <!-- 页面主体 -->
    <div class="main-container">
      <!-- 告警设置 -->
      <div class="title">告警设置</div>
      <!-- 告警方式 -->
      <div class="sub-title">
        <div class="label">告警方式</div>
        <el-popover
          placement="right"
          title
          width="400"
          trigger="hover"
          :visible-arrow="false"
          content="您可依据个人使用习惯开启或关闭短信和邮件告警，并设置告警手机号码和邮箱地址"
        >
          <img slot="reference" class="img" src="@/assets/img/question-circle.svg" />
        </el-popover>
      </div>
      <div class="alarm-methods">
        <div class="row between email-alarm">
          <div class="lab">邮件提醒</div>
          <el-switch
            v-model="mailMessageAlarmSwitch"
            @click.stop.native="handleMailAlarmNotificationTypeChange()"
            :class="{'el-switch-core':mailMessageAlarmSwitch===false }"
          ></el-switch>
        </div>
        <div class="row between email-number">
          <div class="label">
            <span>接收邮件</span>
            <span v-if="!mailNumberModify" class="span">{{data.notificationType.mail.address}}</span>
            <div v-if="mailNumberModify" class="mobileModify">
              <input class="input" v-model="tmpMailNumber" />
              <el-button class="cancle" @click="mailNumberModify=false">取消</el-button>
              <el-button class="confirm" @click="mailModifyConfirm">确定</el-button>
            </div>
          </div>
          <el-button
            v-if="data.notificationType.mail.address&&!mailNumberModify"
            class="modify-btn"
            @click="mailModify"
          >修改</el-button>
          <el-button
            v-if="!data.notificationType.mail.address&&!mailNumberModify"
            class="modify-btn"
            @click="mailModify"
          >添加</el-button>
        </div>
      </div>

      <!-- 管理告警公司 -->
      <div class="sub-title">
        <div class="label">管理告警公司</div>
        <el-popover
          placement="right"
          title
          width="400"
          trigger="hover"
          :visible-arrow="false"
          content="您可依据个人使用习惯开启或关闭监控公司的告警功能。开启时，可以设置需要告警的负面舆情类别、设置负面舆情指数的告警阈值。"
        >
          <img slot="reference" class="img" src="@/assets/img/question-circle.svg" />
        </el-popover>
      </div>
      <div class="alarmlist"></div>
      <el-collapse class="manage-alarm-company" accordion>
        <div class="row entity-list-title">
          <div class="label">
            <!-- <i></i>
            <span>监控公司名称</span>-->
            <el-input
              v-model="keyword"
              placeholder="监控公司名称"
              prefix-icon="el-icon-search"
              @keyup.enter.native="onSelectCompanies"
            ></el-input>
          </div>
          <div class="label-word">
            <span>告警开关</span>
          </div>
        </div>

        <!-- 各个公司设置 - 子组件 -->
        <div v-loading="isLoading">
          <div v-for="(item, index) in data.entitySettingList" :key="index">
            <entity-alarm-setting-item
              :name="item.name"
              :status="item.status"
              :categories="item.categories"
              :threshold="item.threshold"
              @refresh="refreshPage"
            ></entity-alarm-setting-item>
          </div>
        </div>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import EntityAlarmSettingItem from '@/components/common/EntityAlarmSettingItem';
import QuestionQuery from '@/rest/questionQuery';

export default {
  data() {
    return {
      keyword: '',
      isLoading: false,
      mobileMessageAlarmSwitch: false,
      mailMessageAlarmSwitch: false,
      mobileNumberModify: false,
      mailNumberModify: false,
      tmpMobileNumber: '',
      tmpMailNumber: '',
      data: {
        notificationType: {
          phone: {
            status: 'off',
            number: ''
          },
          mail: {
            status: 'off',
            address: ''
          }
        },
        entitySettingList: []
      }
    };
  },
  methods: {
    selectCompanies() {
      QuestionQuery.getAlarmSettingsPageList().then(result => {
        if (result.data.notificationType.phone.status === 'on') {
          this.mobileMessageAlarmSwitch = true;
        } else {
          this.mobileMessageAlarmSwitch = false;
        }
        if (result.data.notificationType.mail.status === 'on') {
          this.mailMessageAlarmSwitch = true;
        } else {
          this.mailMessageAlarmSwitch = false;
        }
        this.data.entitySettingList = result.data.entitySettingList.filter(item => {
          if (item.name.indexOf(this.keyword) > -1) {
            return true;
          }
          return null;
        });
      });
    },
    onSelectCompanies() {
      this.data.entitySettingList = [];
      this.selectCompanies();
    },
    refreshPage() {
      if (this.keyword) {
        this.selectCompanies();
      } else {
        this.fetchAlarmSettingsPageList();
      }
    },
    toMainPage() {
      this.$router.push({ path: '/' });
    },
    alarmNotificationType() {
      const mobileMessageAlarmSwitchStatus = this.mobileMessageAlarmSwitch ? 'on' : 'off';
      const mailMessageAlarmSwitchStatus = this.mailMessageAlarmSwitch ? 'on' : 'off';
      const alarmNotificationType = {
        phone: {
          status: mobileMessageAlarmSwitchStatus,
          number: this.data.notificationType.phone.number
        },
        mail: {
          status: mailMessageAlarmSwitchStatus,
          address: this.data.notificationType.mail.address
        }
      };
      const res = QuestionQuery.putAlarmNotificationType(alarmNotificationType);
      if (!res) {
        this.$message.error('修改失败');
      }
    },
    handleMailAlarmNotificationTypeChange() {
      if (this.mailMessageAlarmSwitch) {
        if (this.data.notificationType.mail.address === '') {
          this.mailMessageAlarmSwitch = false;
          this.$message.error('须填写邮箱地址');
          this.alarmNotificationType();
        } else {
          this.alarmNotificationType();
        }
      } else {
        this.alarmNotificationType();
      }
    },
    handleAlarmNotificationTypeChange() {
      // 告警方式所有状态改变的请求处理函数
      if (this.mobileMessageAlarmSwitch) {
        if (this.data.notificationType.phone.number === '') {
          this.mobileMessageAlarmSwitch = false;
          this.$message.error('须填写手机号');
          this.alarmNotificationType();
        } else {
          this.alarmNotificationType();
        }
      } else {
        this.alarmNotificationType();
      }
    },
    mailModifyConfirm() {
      // eslint-disable-next-line
      if (!/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/.test(this.tmpMailNumber) && this.tmpMailNumber !== '') {
        this.$message.error('请输入正确的邮箱地址');
        return;
      }

      this.data.notificationType.mail.address = this.tmpMailNumber;
      this.mailNumberModify = false;
      this.handleMailAlarmNotificationTypeChange();
    },

    mailModify() {
      // 邮箱号码编辑按钮
      this.mailNumberModify = true;
      this.tmpMailNumber = this.data.notificationType.mail.address;
    },

    mobileModifyConfirm() {
      // 确认修改电话号码
      if (!this.mobileNumberCheck(this.tmpMobileNumber)) {
        this.$message.error('请输入正确的手机号码');
        return;
      }
      this.data.notificationType.phone.number = this.tmpMobileNumber;
      this.mobileNumberModify = false;
      this.handleAlarmNotificationTypeChange();
    },

    mobileModify() {
      // 电话号码编辑按钮
      this.mobileNumberModify = true;
      this.tmpMobileNumber = this.data.notificationType.phone.number;
    },

    mobileNumberCheck(mobileNumber) {
      // 电话号码正则检测
      if (!/^1[3456789]\d{9}$/.test(mobileNumber) && mobileNumber !== '') {
        return false;
      }
      return true;
    },
    fetchAlarmSettingsPageList() {
      this.isLoading = true;
      this.itemsShow = false;
      QuestionQuery.getAlarmSettingsPageList().then(result => {
        this.isLoading = false;
        this.data = result.data;
        if (this.data.notificationType.phone.status === 'on') {
          this.mobileMessageAlarmSwitch = true;
        } else {
          this.mobileMessageAlarmSwitch = false;
        }
        if (this.data.notificationType.mail.status === 'on') {
          this.mailMessageAlarmSwitch = true;
        } else {
          this.mailMessageAlarmSwitch = false;
        }
      });
    }
  },
  mounted() {
    this.fetchAlarmSettingsPageList();
  },
  components: {
    EntityAlarmSettingItem
  }
};
</script>

<style lang="scss" scoped>
.img {
  width: 16px;
}
.alarm-settings-page {
  padding-bottom: 48px;
  color: #ffffff;
  font-size: 14px;
  min-height: calc(100vh - 64px);
  background-color: #343239;
  overflow: hidden;
  .alarm-page-loading {
    top: 30vh;
  }
  .el-button {
    color: #45a8cc;
    border-radius: 2px;
    border: solid 1px #605e61;
    background-color: transparent;
    &:hover {
      background-color: rgba(255, 255, 255, 0.08);
    }
  }
  .back-btn {
    position: fixed;
    justify-content: center;
    align-items: center;
    left: 32px;
    top: 96px;
    width: 40px;
    height: 40px;
    background-color: #3b3a3f;
    border-radius: 4px;
    &:hover {
      background-color: #423f43;
    }
  }
  .main-container {
    margin: 0 auto;
    padding-top: 32px;
    width: 640px;
    .row.between {
      justify-content: space-between;
      align-items: center;
      padding: 0 24px;
    }
    .title {
      font-size: 32px;
    }
    .main-switch {
      margin-top: 24px;
      width: 640px;
      height: 48px;
      background-color: #3b3a3f;
      border-radius: 8px;
    }
    .sub-title {
      margin-top: 24px;
      color: rgba(255, 255, 255, 0.8);
      font-size: 16px;
      .label {
        float: left;
      }
      .img {
        vertical-align: middle;
        margin-left: 4px;
        opacity: 0.3;
      }
    }
    .alarm-methods {
      margin-top: 8px;
      width: 640px;
      height: 96px;
      border-radius: 8px;
      background-color: #3b3a3f;
      .mobile-message-alarm {
        height: 48px;
      }
      .mobile-number {
        margin-left: 24px;
        height: 48px;
        border-top: 1px solid #00000033;
        box-sizing: border-box;
        .label {
          color: rgba(255, 255, 255, 0.6);
          .span {
            min-width: 2px;
            height: 48px;
            margin-left: 24px;
            color: #ffffff;
          }
          .mobileModify {
            margin-left: 12px;
            display: inline-block;
            .input {
              padding-left: 12px;
              width: 160px;
              height: 32px;
              color: #ffffff;
              border-radius: 4px;
              border: solid 1px #45a8cc;
              background-color: #27252a;
              box-sizing: border-box;
              outline: none;
              -moz-appearance: textfield;
              &::-webkit-inner-spin-button,
              &::-webkit-outer-spin-button {
                -webkit-appearance: none;
                margin: 0;
              }
            }
            .cancle,
            .confirm {
              padding: 0;
              color: #ffffff;
              width: 52px;
              height: 32px;
            }
            .cancle {
              margin-left: 12px;
            }
            .confirm {
              background-color: #45a8cc;
              &:hover {
                background-color: #45a8cc80;
              }
            }
          }
        }
        .modify-btn {
          padding: 0;
          width: 52px;
          height: 32px;
          border-radius: 2px;
          border: solid 1px #605e61;
          box-sizing: border-box;
        }
      }
      .email-alarm {
        height: 48px;
        box-sizing: border-box;
        border-top: 1px solid #00000033;
      }
      .email-number {
        margin-left: 24px;
        height: 48px;
        border-top: 1px solid #00000033;
        box-sizing: border-box;
        .label {
          color: rgba(255, 255, 255, 0.6);
          .span {
            min-width: 2px;
            height: 48px;
            margin-left: 24px;
            color: #ffffff;
          }
          .mobileModify {
            margin-left: 12px;
            display: inline-block;
            .input {
              padding-left: 12px;
              width: 160px;
              height: 32px;
              color: #ffffff;
              border-radius: 4px;
              border: solid 1px #45a8cc;
              background-color: #27252a;
              box-sizing: border-box;
              outline: none;
              -moz-appearance: textfield;
              &::-webkit-inner-spin-button,
              &::-webkit-outer-spin-button {
                -webkit-appearance: none;
                margin: 0;
              }
            }
            .cancle,
            .confirm {
              padding: 0;
              color: #ffffff;
              width: 52px;
              height: 32px;
            }
            .cancle {
              margin-left: 12px;
            }
            .confirm {
              background-color: #45a8cc;
              &:hover {
                background-color: #45a8cc80;
              }
            }
          }
        }
        .modify-btn {
          padding: 0;
          width: 52px;
          height: 32px;
          border-radius: 2px;
          border: solid 1px #605e61;
          box-sizing: border-box;
        }
      }
    }
    .manage-alarm-company {
      margin-top: 8px;
      border: none;
      border-radius: 8px;
      background-color: #3b3a3f;
      .entity-list-title {
        padding: 0 70px 0 14px;
        justify-content: space-between;
        align-items: center;
        height: 48px;
        .label {
        }
        .label-word {
          color: rgba(255, 255, 255, 0.6);
        }
      }
    }
  }
}
/deep/.el-input .el-input__inner {
  border: none;
  color: #ffffff;
  background-color: #3b3a3f !important;
}
.el-switch-core /deep/.el-switch__core {
  border: 1px solid transparent;
  background-color: #646367;
}
</style>
